import { combineReducers } from 'redux';
import { RootAction } from '@src/app/_redux';
import {
  REFUND_STORE_CREDIT_LOADING,
  REFUND_STORE_CREDIT_ERROR,
  REFUND_STORE_CREDIT_START,
  REFUND_STORE_CREDIT_SUCCESS,
  REFUND_STORE_CREDIT_CANCEL,
} from '@src/app/accounts/refundstorecredit/actions';
import { OMS_LOOKUP_SUCCESS } from '@src/app/login/oms/actions';
export type State = {
  readonly loading: boolean;
  refundStoreCreditSavedResult: Object | null;
};

export const reducer = combineReducers<State, RootAction>({
  loading: (state = false, action) => {
    switch (action.type) {
      case REFUND_STORE_CREDIT_ERROR:
      case REFUND_STORE_CREDIT_START:
      case OMS_LOOKUP_SUCCESS:
        return false;
      case REFUND_STORE_CREDIT_LOADING:
        return action.payload;
      default:
        return state;
    }
  },

  refundStoreCreditSavedResult: (state = null, action) => {
    switch (action.type) {
      case REFUND_STORE_CREDIT_SUCCESS:
      case REFUND_STORE_CREDIT_ERROR:
        return action.payload;
      case REFUND_STORE_CREDIT_CANCEL:
      case REFUND_STORE_CREDIT_START:
        return null;
      default:
        return state;
    }
  },
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/accounts/refundstorecredit/reducer.ts